import React from "react";
import AprReport from "components/APR_Report";

export default function ProgressReport() {
  return <AprReport embedded />;
}
